import { Button } from '@monksflow/monks-ui';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import type { ArtifactPreviewNavigationProps } from './ArtifactPreviewModal.types';
import { useArtifactNavigation } from './hooks/useArtifactNavigation';
import { useTranslation } from 'react-i18next';

/**
 * Top-left chrome for the preview modal. Prev/next icon buttons disable at the
 * grid-page boundary (see `useArtifactNavigation` for the no-wrap rationale).
 * Keyboard ArrowLeft/Right is wired by the navigation hook itself, so the
 * buttons are pure click-target ergonomics here.
 */
export function ArtifactPreviewNavigation(props: ArtifactPreviewNavigationProps) {
  const { t } = useTranslation('projects');

  const { prevId, nextId, goPrev, goNext } = useArtifactNavigation(props.projectId);

  return (
    <div className="flex items-center gap-1">
      <Button
        variant="ghost"
        size="mini"
        aria-label={t('projectDetail.artifactPreviewNavigation.previousArtifact')}
        disabled={prevId === null}
        onClick={goPrev}
        className="size-8 p-0"
      >
        <ChevronLeftIcon className="size-4" />
      </Button>
      <Button
        variant="ghost"
        size="mini"
        aria-label={t('projectDetail.artifactPreviewNavigation.nextArtifact')}
        disabled={nextId === null}
        onClick={goNext}
        className="size-8 p-0"
      >
        <ChevronRightIcon className="size-4" />
      </Button>
    </div>
  );
}
